"use client";

import { ChevronUp } from "lucide-react";
import ScrollToTop from "react-scroll-to-top";

const BackToTop = () => {
  return (
    <ScrollToTop
      smooth
      component={<ChevronUp color="currentColor" size={27} />}
      style={{
        backgroundColor: "var(--color-primary)",
        borderRadius: "0px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
        color: "white",
        width: "54px",
        height: "54px",
      }}
    />
  );
};

export default BackToTop;
